import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { map, Observable, of } from "rxjs";

@Pipe({
  name: 'timeAgo',
  pure: true
})
export class TimeAgoPipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(value: any, suffix: string = ' پیش'): Observable<any> {

    if (value) {
      return this.translate.get([suffix, 'AFEWMOMENTS', 'month', 'week', 'day', 'hour', 'minute', 'second', 'year']).pipe(map((x: any) => {
        if (value.indexOf('T') > -1 && !value.endsWith('Z') && !value.endsWith('z')) value += 'Z';
        const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
        if (seconds < 29) // less than 30 seconds ago will show as 'Just now'
          return x['AFEWMOMENTS'] + ' ' + x[suffix];

        const intervals = {
          'year': 31536000,
          'month': 2592000,
          'week': 604800,
          'day': 86400,
          'hour': 3600,
          'minute': 60,
          'second': 1
        };
        let counter;
        for (let [key, value] of Object.entries(intervals)) {
          counter = Math.floor(seconds / value);
          if (counter > 0)
            return `${counter} ${x[key]} ${x[suffix]}`;
        }
        return '';
      }))

    }
    return of(value);
  }

}
